import Axios from "axios";
import { facilityPricingUrls } from "../urls";
import router from "../../../router";

export default {
  get_all_facility_pricings(context) {
    Axios.get(facilityPricingUrls.getAllFacilityPricings).then(function(
      response
    ) {
      context.commit("GET_ALL_FACILITY_PRICINGS", response.data);
    });
  },

  get_current_facility_pricing(context, publicId) {
    Axios.get(facilityPricingUrls.getCurrentFacilityPricing + publicId).then(
      function(response) {
        context.commit("GET_FACILITY_PRICINGS", response.data);
      }
    );
  },
  get_facility_pricings(context, publicId) {
    Axios.get(facilityPricingUrls.getFacilityPricings + publicId).then(function(
      response
    ) {
      context.commit("GET_FACILITY_PRICINGS", response.data);
    });
  },
  get_deleted_facility_pricings(context) {
    Axios.get(facilityPricingUrls.getDeletedFacilityPricing).then(function(
      response
    ) {
      context.commit("GET_DELETED_FACILITY_PRICINGS", response.data);
    });
  },
  get_facility_pricing(context, publicId) {
    Axios.get(facilityPricingUrls.getFacilityPricing + publicId)
      .then(function(response) {
        context.commit("GET_FACILITY_PRICING", response.data);
      })
      .catch(function() {
        context.commit("GET_FACILITY_PRICING", { data: [] });
      });
  },
  post_facility_pricing(context, data) {
    Axios.post(facilityPricingUrls.postFacilityPricing, data)
      .then(function() {
        context.dispatch("get_facility_pricing", data.facility_id);
      })
      .catch(function(error) {
        context.commit("UPDATE_ERRORS", error.data);
      });
  },
  update_facility_pricing(context, data) {
    Axios.post(facilityPricingUrls.editFacilityPricing + data.public_id, data)
      .then(function() {
        context.dispatch("get_facility_pricing", data.facility_id);
      })
      .catch(function(error) {
        context.commit("UPDATE_ERRORS", error.data);
      });
  },
  delete_facility_pricing(context, data) {
    Axios.post(
      facilityPricingUrls.deleteFacilityPricing + data.public_id,
      data
    ).then(function(response) {
      context.dispatch("get_facility_pricing", data.facility_id);
    });
  },
  restoreFacilityPricing(context, publicId) {
    Axios.get(facilityPricingUrls.restoreFacilityPricing + publicId).then(
      function(response) {
        alert(response.data.message);
        context.commit("GET_ALL_FACILITY_PRICINGS", response.data);
        router.push({
          name: "Module.FacilityPricings"
        });
      }
    );
  }
};
